<template>
	<div id="single-card-container">
		<div v-if="isLoading"><i class="fad fa-spinner-third fa-spin fa-2x"></i></div>
		<div v-else>
			<h1 v-if="userRec">Scorecard for {{userRec.nameFirst}} {{userRec.nameLast}}</h1>
			<div id="scorecard-profile" v-if="cardsAll">
				<div id="scorecard-results">
					<table>
					<thead>
						<tr>
							<th>
								Adjudicator
							</th>
							<th>
								Essay (40%)
							</th>
							<th>
								Dance (50%)
							</th>
							<th>
								LOR/FIN (10%)
							</th>
							<th class="total">
								Total
							</th>
							<th class="average">
								Average
							</th>
							<th class="weighted">
								Weighted
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="card in cardsAll" v-bind:key="card.id">
							<td class="label">
								<span v-if="findAdjudicator(card.adjudicator)">{{findAdjudicator(card.adjudicator).nameFirst}} {{findAdjudicator(card.adjudicator).nameLast}}</span>
							</td>
							<td class="num">
								{{card.goal}}
							</td>
							<td class="num">
								{{card.dance}}
							</td>
							<td class="num">
								{{card.letter}}
							</td>
							<td class="total num">
								{{totalScoreAdjudicator(card)}}
							</td>
							<td class="average num">
								{{averageScoreAdjudicator(card)}}
							</td>
							<td class="weighted num">
								{{weightedScore(card)}}%
							</td>
						</tr>
						<tr class="totals">
							<td class="label">
								Total
							</td>
							<td class="num">
								{{totals('goal')}}
							</td>
							<td class="num">
								{{totals('dance')}}
							</td>
							<td class="num">
								{{totals('letter')}}
							</td>
							<td class="num">
								{{totalsRow(totals('goal'),totals('dance'),totals('letter'))}}
							</td>
							<td class="average num">
								{{totalsRowAvg(totals('goal'),totals('dance'),totals('letter'))}}
							</td>
							<td class="blocked">
								&nbsp;
							</td>
						</tr>
						<tr id="average" class="totals">
							<td class="label">
								Average
							</td>
							<td class="num">
								{{averageScore('goal')}}
							</td>
							<td class="num">
								{{averageScore('dance')}}
							</td>
							<td class="num">
								{{averageScore('letter')}}
							</td>
							<td class="num">
								{{totalsRow(averageScore('goal'),averageScore('dance'),averageScore('letter'))}}
							</td>
							<td class="average num">
								{{totalsRowAvg(averageScore('goal'),averageScore('dance'),averageScore('letter'))}}
							</td>
							<td class="blocked">
								&nbsp;
							</td>
						</tr>
						<tr id="weighted" class="totals">
							<td class="label">
								Weighted
							</td>
							<td class="num">
								{{avgWeighted(averageScore('goal'),'goal')}}%
							</td>
							<td class="num">
								{{avgWeighted(averageScore('dance'),'dance')}}%
							</td>
							<td class="num">
								{{avgWeighted(averageScore('letter'),'letter')}}%
							</td>
							<td id="final" class="num">
								{{weightedFinal(avgWeighted(averageScore('goal'),'goal'),avgWeighted(averageScore('dance'),'dance'),avgWeighted(averageScore('letter'),'letter'))}}%
							</td>
							<td class="blocked">
							</td>
							<td class="blocked">
							</td>
						</tr>
					</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			isLoading: false,
			userId: this.$route.params.id,
		}
	},
	computed: {
		noOfCards(){
			return this.cardsAll.length
		},
		cardsAll(){
			return this.$store.getters.cardsAll
		},
		userRec(){
			return this.$store.getters.userSingle(this.$route.params.id)
		},
	},
	methods: {
		findAdjudicator(userId){
			return this.$store.getters.usersAdjudicators.find(user => user.id === userId)
		},
		async loadScores(id) {
			this.isLoading = true
			await this.$store.dispatch('loadUsers')
			await this.$store.dispatch('loadScoreCards',id)
			this.isLoading = false
		},
		totals(which){
			let total = 0
			this.$store.getters.cardsAll.forEach(element => {
				total += parseFloat(element[which])
			});
			return total
		},
		averageScore(which){
			return this.totals(which) / this.noOfCards
		},
		totalScoreAdjudicator(card){
			card.goal = card.goal || 0
			card.dance = card.dance || 0
			card.letter = card.letter || 0
			return (+card.goal + +card.dance + +card.letter).toFixed(1)
		},
		averageScoreAdjudicator(card){
			return parseFloat(( (+card.goal + +card.dance + +card.letter) / 3)).toFixed(1)
		},
		totalsRow(val1,val2,val3){
			return parseFloat(+val1 + +val2 + +val3).toFixed(1)
		},
		totalsRowAvg(val1,val2,val3){
			return parseFloat(((+val1 + +val2 + +val3) / 3).toFixed(1))
		},
		weightedScore(card){
			let weights = {
				'goal': 40,
				'dance': 50,
				'letter': 10
			}

			//return  (((card.goal * weights.goal) / this.noOfCards ) + ((card.dance * weights.dance) / this.noOfCards) + ((card.letter * weights.letter) / this.noOfCards))

			return  (((card.goal * weights.goal) / 5 ) + ((card.dance * weights.dance) / 5) + ((card.letter * weights.letter) / 5))



		},
		avgWeighted(amt,which){
			let weights = {
				'goal': 40,
				'dance': 50,
				'letter': 10
			}
			//return ((amt * weights[which]) / this.noOfCards ).toFixed(1)
			return ((amt * weights[which]) / 5 ).toFixed(1)
		},
		weightedFinal(val1,val2,val3){
			return (+val1 + +val2 + +val3).toFixed(1)
		}
	},
	async created(){
		await this.loadScores(this.$route.params.id)
	}
}
</script>
<style scoped>
:root {
	--ar-purple: #483751;
}

table {
	width: 100%;
}

table,
table th,
table td {
	border: 1px solid var(--ar-purple);
	padding: 3px;
}

	table td.label {
		padding-right: 6px;
		padding-left: 6px;
	}

	#average td {
		background-color: rgba(72,55,81,.12);
	}

	#weighted td {
		background-color: rgba(72,55,81,.18);
	}

	table th {
		background-color: var(--ar-purple);
		border-right: 1px solid rgba(255,255,255,.33);
		border-left: 1px solid rgba(255,255,255,.33);
		color: #fff;
		font-weight: bold;
		text-align: center;
	}

		table th:first-child {
			border-left: 1px solid rgba(72,55,81,1);
		}

	.totals td {
		background-color: rgba(72,55,81,.06);
		color: var(--ar-purple);
		font-weight: bold;
	}

	th.total,
	th.average,
	th.weighted,
	td.total {
		background-color: rgba(72,55,81,.06);
		border-right: 1px solid rgba(72,55,81,1);
		color: var(--ar-purple);
		font-weight: bold;
	}

	th.average,
	td.average {
		background-color: rgba(72,55,81,.12);
		font-weight: bold;
	}

	td.weighted,
	th.weighted {
		background-color: rgba(72,55,81,.18);
		font-weight: bold;
	}
	
	td.num {
		text-align: center;
	}

	td.blocked,
	#average td.blocked,
	#weighted td.blocked {
		background-color: #333;
	}

	td#final {
		background-color: #800000;
		color: #fff;
	}
</style>